import { useSignInMutation, useSignInVerifyMutation } from '../graphql/generated/graphql'
import { gql } from '@apollo/client'

gql`
  mutation SignIn($email: String!, $phoneNumber: String!) {
    signIn(input: { phoneNumber: $phoneNumber, email: $email }) {
      retryInSeconds
      error
    }
  }

  mutation SignInVerify($code: String!, $phoneNumber: String!, $email: String!, $mainSite: Boolean!) {
    signInVerify(input: { phoneNumber: $phoneNumber, code: $code, email: $email, mainSite: $mainSite }) {
      accessToken
      error
      websiteUrl
    }
  }
`

export const useSignIn = () => {
  const [signIn, { loading }] = useSignInMutation()
  const [signInVerify] = useSignInVerifyMutation()

  const handleSendSignInCode = (phoneNumber: string, email: string) => signIn({ variables: { phoneNumber, email } })

  const handleVerifySignInCode = (phoneNumber: string, email: string, code: string, mainSite: boolean) =>
    signInVerify({ variables: { phoneNumber, email, code, mainSite } })

  return { sendSignInCode: handleSendSignInCode, verifySignInCode: handleVerifySignInCode, loading }
}
